import axios, { AxiosInstance, AxiosPromise } from 'axios';
import config from '@/appConfig.json';
import { Survey, SurveyResponse } from '@/store/models';

export default class SurveyService {

	public static getInstance(): SurveyService {
		return new this();
	}
	private resourceUrl: string =  '/surveys/';

	private apiClient: AxiosInstance =	axios.create({
		baseURL: config.apiUrl,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.accessToken
		}
	});

	// TODO make to promise
	public getSurveys(): AxiosPromise {
		return this.apiClient.get(this.resourceUrl);
	}

	public async getSurvey(id: number): Promise<Survey> {
		const response = await this.apiClient.get(this.resourceUrl + id);
		return (response.data as SurveyResponse).survey;
	}
}
